import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/order_line_estimate/{district_id}
export const orderEstimateWithoutFS = async (
  districtId: number,
  payload: Object
): Promise<TOrderItem[][]> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/order_line_estimate_without_fs/${districtId}`, Util.Obj.keysToSnake(payload))
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data.estimate) as TOrderItem[][])
      })
      .catch(err => {
        reject('Failed to get order estimate without FS: ' + err)
      })
  })
}
